import { FC, ReactNode } from 'react';

import { Stack, StackProps } from '@chakra-ui/react';

import { SessionList } from '@/components/features/SessionList';
import { Session } from '@/types/chat.ts';

interface Props {
  isSessionsMode?: boolean;
  sessions: Session[];
  onSessionChangeClick?: (session: Session) => void;
  onReturnToChatClick?: () => void;
  sessionListClassName?: string;
  containerProps?: StackProps;
  children: ReactNode;
}

const ChatSessionSwitcher: FC<Props> = ({
  isSessionsMode,
  sessions,
  onSessionChangeClick,
  onReturnToChatClick,
  sessionListClassName,
  containerProps,
  children,
}) => {
  return (
    <Stack
      position='relative'
      flex={1}
      minH={0}
      overflow='hidden'
      {...containerProps}
    >
      <Stack
        position='absolute'
        inset={0}
        minH={0}
        overflow='hidden'
        opacity={isSessionsMode ? 1 : 0}
        pointerEvents={isSessionsMode ? 'auto' : 'none'}
        zIndex={1}
      >
        <SessionList
          sessions={sessions}
          onSessionChangeClick={onSessionChangeClick}
          onReturnToChatClick={onReturnToChatClick}
          className={sessionListClassName}
        />
      </Stack>
      <Stack
        position='absolute'
        inset={0}
        h='full'
        minH={0}
        overflow='hidden'
        opacity={isSessionsMode ? 0 : 1}
        pointerEvents={isSessionsMode ? 'none' : 'auto'}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export { ChatSessionSwitcher };
